import { Card } from "@/core/components/ui/card";
import { Skeleton } from "@/core/components/ui/skeleton";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";

// Placeholder cards in the shape of the real ones, so the panel does not jump
// when the edits load.
export const ManualEditsSkeleton = () => (
  <Stack gap="sm" fullWidth role="status" aria-label="Loading manual edits">
    <Skeleton className="mb-1 h-5 w-32" />
    {[0, 1, 2].map((index) => (
      <Card
        key={index}
        className="w-full rounded-2xl border-stroke-tertiary p-4 shadow-none"
      >
        <Stack gap="sm" fullWidth align="stretch">
          <Stack direction="row" justify="between" fullWidth>
            <Skeleton className="h-4 w-36" />
            <Skeleton className="h-5 w-20 rounded-lg" />
          </Stack>
          <Skeleton className="h-5 w-28" />
          <Skeleton className="h-3 w-40" />
        </Stack>
      </Card>
    ))}
  </Stack>
);

export const ManualEditsEmptyState = () => (
  <Typography
    variant="bodyW1"
    textColor="secondary"
    className="pt-6 text-center"
  >
    Nothing edited yet. Change a cell or add a row in the workbook and it shows
    up here, then applies again the next time payroll runs.
  </Typography>
);
